import React, { useEffect, useState } from 'react';
import useToken from './components/useToken';
import axios from 'axios';
import { Navigate, Outlet } from 'react-router-dom';

function CohortGuard() {
  const { token } = useToken();
  const [isInCohort, setIsInCohort] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) {
      setIsInCohort(false);
      setLoading(false);
      return;
    }

    const checkCohortStatus = async () => {
      try {
        const cohortResponse = await axios.get(
          'https://genz-staging.feeltiptop.com/api/user/check-cohort',
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (cohortResponse.data.inCohort) {
          setIsInCohort(true);
        } else {
          setIsInCohort(false);
          setError('Access Denied: You must be part of a cohort.');
        }
      } catch (err) {
        setError('Error fetching cohort status');
        setIsInCohort(false);
      } finally {
        setLoading(false);
      }
    };

    checkCohortStatus();
  }, [token]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!isInCohort) return <Navigate to="/login" replace />;

  return <Outlet />;
}

export default CohortGuard;
